export const Types = {
  FETCH_IDENTIDADE_VISUAL_REQUEST: "identidadeVisual/FETCH_IDENTIDADE_VISUAL_REQUEST",
  FETCH_IDENTIDADE_VISUAL_SUCCESS: "identidadeVisual/FETCH_IDENTIDADE_VISUAL_SUCCESS",
  FETCH_IDENTIDADE_VISUAL_FAILURE: "identidadeVisual/FETCH_IDENTIDADE_VISUAL_FAILURE",
};

const INITIAL_STATE = {
  data: {
    cores: {
      cor_primaria: null,
      topbar_fundo: null,
      topbar_texto: null,
      barra_cor_fundo: null,
      header_fundo: null,
      header_texto: null,
      navbar_fundo: null,
      navbar_texto: null,
      rodape_fundo: null,
      rodape_texto: null,
    },
    logo_header: null,
    logo_rodape: null,
    titulo_site: null,
    descricao_site: null,
    topbar_botoes: [],
    barra_avisos: [],
    rodape_grupos: [],
    rodape_pagamentos: [],
    rodape_aviso_legal: null,
  },
  loading: false,
  error: null,
};

export default function identidadeVisual(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.FETCH_IDENTIDADE_VISUAL_REQUEST:
      return { ...state, loading: true, error: null };
    case Types.FETCH_IDENTIDADE_VISUAL_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case Types.FETCH_IDENTIDADE_VISUAL_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export const Creators = {
  fetchIdentidadeVisualRequest: () => ({
    type: Types.FETCH_IDENTIDADE_VISUAL_REQUEST,
  }),
  fetchIdentidadeVisualSuccess: (data) => ({
    type: Types.FETCH_IDENTIDADE_VISUAL_SUCCESS,
    payload: data,
  }),
  fetchIdentidadeVisualFailure: (error) => ({
    type: Types.FETCH_IDENTIDADE_VISUAL_FAILURE,
    payload: error,
  }),
};
